var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#48ABCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6388 9.27994C18.8392 9.45529 18.8595 9.75989 18.6841 9.96029L11.9341 17.6746C11.8463 17.775 11.7207 17.8345 11.5873 17.839C11.454 17.8434 11.3247 17.7924 11.2304 17.698L8.33751 14.8051C8.14922 14.6169 8.14922 14.3116 8.33751 14.1233C8.52579 13.935 8.83107 13.935 9.01936 14.1233L11.5478 16.6517L17.9584 9.3253C18.1338 9.1249 18.4384 9.1046 18.6388 9.27994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.dcbd4da102fde440c77ad78c0bf94570.svg";
export { ForwardRef as ReactComponent };